import { Flex, IconButton, Text } from "@chakra-ui/react";
import { MdClose } from "react-icons/md";
import { SupportAttachment } from "../../hooks/useMessagesTab";

type Props = {
  files: SupportAttachment[];
  onRemove: (fileId: string) => void;
};

export default function AttachmentsChips({ files, onRemove }: Props) {
  if (files.length === 0) return null;

  return (
    <Flex gap="10px" wrap="wrap" mt="12px">
      {files.map((f) => (
        <Flex
          key={f.id}
          align="center"
          gap="8px"
          px="10px"
          py="6px"
          border="1px solid #E6ECF3"
          borderRadius="10px"
          bg="#FFFFFF"
        >
          <Text fontSize="14px" color="#0B0E10" maxW="240px" noOfLines={1}>
            {f.fileName}
          </Text>
          <IconButton
            aria-label="Remove attachment"
            icon={<MdClose />}
            size="sm"
            variant="ghost"
            onClick={() => onRemove(f.id)}
          />
        </Flex>
      ))}
    </Flex>
  );
}
